import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Announcements from "@/components/Announcements";
import FeaturedProducts from "@/components/FeaturedProducts";
import BrandPartners from "@/components/BrandPartners";
import Solutions from "@/components/Solutions";
import WhyChooseUs from "@/components/WhyChooseUs";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import natureBackground from "@/assets/nature-background.jpg";

const Index = () => {
  return (
    <>
      <SEOHead
        title="ECONTROL - Innovación y Soluciones para el Control de Plagas"
        description="Líderes en soluciones sustentables para el control de plagas. Más de 30 años de experiencia ofreciendo productos profesionales eco-friendly para la industria."
        url="/"
      />
      <div 
        className="min-h-screen bg-background bg-scroll md:bg-fixed"
        style={{
          backgroundImage: `url(${natureBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <a href="#main-content" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md">
          Saltar al contenido principal
        </a>
        <div className="min-h-screen bg-background/80">
          <Header />
          <main id="main-content" role="main">
            <Hero />
            <Announcements />
            <FeaturedProducts />
            <Solutions />
            <WhyChooseUs />
            <BrandPartners />
          </main>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Index;
